export const AUTH_REDIRECT_PARAM = 'redirectTo';
export const SIGN_IN_PATH = '/sign-in';
export const DEFAULT_POST_LOGIN_REDIRECT_PATH = '/';

const getCurrentLocationPath = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

const isSignInPath = (path: string) =>
  path === SIGN_IN_PATH ||
  path.startsWith(`${SIGN_IN_PATH}?`) ||
  path.startsWith(`${SIGN_IN_PATH}#`);

const isSafeRelativePath = (path: string) =>
  path.startsWith('/') && !path.startsWith('//');

export const createSignInRedirectPath = (
  currentPath = getCurrentLocationPath(),
) => {
  if (!currentPath || isSignInPath(currentPath)) {
    return SIGN_IN_PATH;
  }

  const searchParams = new URLSearchParams();
  searchParams.set(AUTH_REDIRECT_PARAM, currentPath);

  return `${SIGN_IN_PATH}?${searchParams.toString()}`;
};

export const getPostLoginRedirectPath = (search = window.location.search) => {
  const redirectPath = new URLSearchParams(search).get(AUTH_REDIRECT_PARAM);

  if (
    !redirectPath ||
    !isSafeRelativePath(redirectPath) ||
    isSignInPath(redirectPath)
  ) {
    return DEFAULT_POST_LOGIN_REDIRECT_PATH;
  }

  return redirectPath;
};
